'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _InputConstants = require('./InputConstants');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _IMESafe = require('../decorators/IMESafe');

var _IMESafe2 = _interopRequireDefault(_IMESafe);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _Functions = require('../core/Functions');

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TYPES = ['text', 'email', 'number', 'password', 'search', 'url'];

var UITextInput = _react2.default.createClass({
  displayName: 'UITextInput',

  propTypes: {
    defaultValue: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    inputRef: _refObject2.default,
    onChange: _react.PropTypes.func,
    placeholder: (0, _createLazyPropType2.default)(_react.PropTypes.string),
    readOnly: _react.PropTypes.bool,
    styled: _react.PropTypes.bool.isRequired,
    type: _react.PropTypes.oneOf(TYPES),
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      styled: true,
      type: 'text'
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        error = _props.error,
        inputRef = _props.inputRef,
        placeholder = _props.placeholder,
        styled = _props.styled,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['className', 'error', 'inputRef', 'placeholder', 'styled', 'use']);

    return _react2.default.createElement(
      _FieldsetContext.Consumer,
      null,
      function (_ref) {
        var fieldSize = _ref.size;
        return _react2.default.createElement('input', _extends({}, rest, {
          className: (0, _classNames2.default)('form-control private-form__control', _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], className, {
            'private-form__control--unstyled uiTextInputUnstyled': !styled,
            'private-form__control--error': error
          }, _InputConstants.USE_CLASSES[use]),
          placeholder: (0, _lazyEval2.default)(placeholder),
          ref: (0, _Functions.wrapRefObject)(inputRef)
        }));
      }
    );
  }
});

exports.default = (0, _ShareInput2.default)((0, _IMESafe2.default)(UITextInput));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/UITextInput.js
// module id = 230
// module chunks = 3 4 5